import { useCallback, useRef } from 'react'

interface UseSingleRetryResult {
  onFailure: () => void
  onSuccess: () => void
}

/**
 * Allows one retry, re-armed by the next success. Re-signing a Rolodex URL
 * yields a different URL every time, so an unbounded retry loops forever on a
 * file that is missing rather than expired.
 */
export function useSingleRetry(retry: () => void): UseSingleRetryResult {
  const hasRetriedRef = useRef(false)

  const onFailure = useCallback(() => {
    if (hasRetriedRef.current) return
    hasRetriedRef.current = true
    retry()
  }, [retry])

  const onSuccess = useCallback(() => {
    hasRetriedRef.current = false
  }, [])

  return { onFailure, onSuccess }
}
